var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: _vm.title, loading: _vm.loading } },
    [
      _c("sc-form", {
        ref: "form",
        attrs: {
          form: _vm.form,
          rules: _vm.rules,
          hasStyle: false,
          buttonsStyle: false
        },
        on: { submit: _vm.onGetPreInvoices },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              var isValid = ref.isValid
              return [
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column page-container" },
                    [
                      _c("sc-pre-invoice-generation-form", {
                        attrs: {
                          fields: fields,
                          "is-valid": isValid,
                          "loading-exports": _vm.loadingExports
                        },
                        on: {
                          clearFilters: _vm.clearFilters,
                          exportToExcel: _vm.onExportToExcel
                        }
                      }),
                      _vm._v(" "),
                      _vm.invoices.length > 0 && !_vm.loading
                        ? _c("sc-pre-invoice-generation-table", {
                            attrs: { form: _vm.form, invoices: _vm.invoices },
                            on: { generatePreInvoice: _vm.onSendPreInvoice }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b716252", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b716252","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-generation/PagePreInvoiceGeneration.vue
// module id = null
// module chunks = 